/**
 * Локали приложения
 */
export const Locale = {
    KK: 'kk',
    RU: 'ru',
} as const;

export const FALLBACK_LOCALE = Locale.RU;

/**
 * Языки для переключателя
 */
export const LOCALES = [
    { code: Locale.RU, name: 'RU' },
    { code: Locale.KK, name: 'KZ' },
];

/**
 * Локали, на которые пользователь может переключиться
 */
export const AVAILABLE_LOCALES: string[] = LOCALES.map(({ code }) => code);

/**
 * Кука с выбранным языком
 */
export const LOCALE_COOKIE_NAME = 'crm_lng';

/**
 * Обработчик плюрализации, как в mono-spa: 'нет лидов | {n} лид | {n} лида | {n} лидов'
 *
 * Первая форма в массиве должна быть для 0
 *
 * @param choice - число передаваемое в перевод
 * @param choicesLength - кол-во форм перевода
 */
export const pluralizationRule = (choice: number, choicesLength: number): number => {
    if (choice === 0) {
        return 0;
    }

    const mod100 = choice % 100;
    const mod10 = choice % 10;
    const teen = mod100 > 10 && mod100 < 20;

    if (!teen && mod10 === 1) {
        return 1;
    }

    if (!teen && mod10 >= 2 && mod10 <= 4) {
        return 2;
    }

    return (choicesLength < 4) ? 2 : 3;
};
